import { Chip } from "@mui/material";
import { getcolorBadge } from "helpers/colorBadge";

interface Props {
  status: string;
  /** Pill sólido para headers escuros */
  surface?: "default" | "dark";
}

const darkBadgeTone: Record<string, { bgcolor: string; color: string }> = {
  Pago: { bgcolor: "#10B981", color: "#fff" },
  Pendente: { bgcolor: "#FBBF24", color: "#1a2035" },
  Cancelado: { bgcolor: "#EF4444", color: "#fff" },
  Cortesia: { bgcolor: "#3B82F6", color: "#fff" },
  Gratuito: { bgcolor: "#8B5CF6", color: "#fff" },
  RecOrganizador: { bgcolor: "#14B8A6", color: "#fff" },
};

export default function InscricaoStatus({ status, surface = "default" }: Props) {
  if (!status) return null;

  const label = status;
  const color = getcolorBadge(status);

  if (surface === "dark") {
    const tone = darkBadgeTone[status] ?? {
      bgcolor: "rgba(255,255,255,0.18)",
      color: "#fff",
    };

    return (
      <Chip
        label={label}
        size="small"
        sx={{
          bgcolor: tone.bgcolor,
          color: tone.color,
          fontWeight: 700,
          fontSize: "0.75rem",
          letterSpacing: "0.02em",
          border: "none",
          height: 26,
          boxShadow: "0 2px 6px rgba(0,0,0,0.22)",
          "& .MuiChip-label": { px: 1.5 },
        }}
      />
    );
  }

  return <Chip label={label} variant="outlined" color={color} sx={{ px: 2 }} />;
}
